var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{ref:"notification",staticClass:"notification",class:_vm.classNotification,style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }